<div class="feedback-icons" [ngClass]="{'feedback-submitted': feedbackSubmitted}">
  <i class="thumbs-up-icon" [ngClass]="{'active': feedbackType === 'thumbsUp'}" (click)="provideFeedback('thumbsUp')" [kmdTooltip]="usefulContent" tooltipPlacement="bottom">
    <svg class="size-16px" id="thumbs-up-bold.svg" width="16" height="16" viewBox="0 0 24 24" fill="#54545C"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M6.33006 19.4171V8.4401H1.56616V19.4171H6.33006Z" />
      <path
        d="M10.1758 19.4229C9.56765 18.9764 8.88338 18.6897 8.33006 18.5118V9.5989H9.19076C9.22176 9.6099 9.92276 9.5999 11.3278 8.5179C13.1908 7.0849 15.4228 4.9299 15.9248 3.5839C16.2058 2.8279 16.7168 2.6429 16.9958 2.6009C17.4778 2.5239 17.9858 2.7549 18.3428 3.2139C18.8998 3.9279 18.9718 4.9669 18.5378 5.9909C18.0158 7.2279 17.6488 8.1719 17.4308 8.7529H20.1578C21.3468 8.7649 22.1068 9.6309 22.1068 10.7109C22.1068 11.2149 21.9148 11.6749 21.6028 12.0229C22.1048 12.3769 22.4338 12.9639 22.4338 13.6259C22.4338 14.3509 22.0398 14.9839 21.4568 15.3219C21.7218 15.6559 21.8808 16.0799 21.8808 16.5399C21.8808 17.3639 21.3708 18.0719 20.6518 18.3609C20.8628 18.6729 20.9868 19.0499 20.9868 19.4549C20.9868 20.5349 20.1128 21.4129 19.0378 21.4129C18.9831 21.4129 18.9232 21.4131 18.8583 21.4132C17.3039 21.4174 12.9068 21.4292 10.1758 19.4229Z"
        />
    </svg>
    <kmd-tooltip-content #usefulContent>
      <span class="tooltip-txt">Useful</span> 
   </kmd-tooltip-content>
  </i>
  <i class="thumbs-down-icon" [ngClass]="{'active': feedbackType === 'thumbsDown'}" (click)="provideFeedback('thumbsDown')" [kmdTooltip]="notusefulContent" tooltipPlacement="bottom">    
    <svg class="size-16px" id="thumbs-down-bold.svg" width="16" height="16" viewBox="0 0 24 24" fill="#54545C"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.33011 5.48813V14.4011H9.18981C9.22181 14.3901 9.92181 14.4001 11.3278 15.4821C13.1908 16.9151 14.4228 19.0701 14.9238 20.4161C15.2058 21.1721 15.7168 21.3571 15.9958 21.3991C16.4778 21.4761 16.9858 21.2451 17.3428 20.7861C17.8998 20.0721 17.9718 19.0331 17.5378 18.0091C17.2229 17.2627 17.3284 16.6231 17.4137 16.1054C17.4699 15.7651 17.5173 15.4775 17.4308 15.2471H20.1578C21.3468 15.2351 22.1058 14.3691 22.1058 13.2891C22.1058 12.7851 21.9148 12.3251 21.6028 11.9771C22.1048 11.6231 22.4338 11.0361 22.4338 10.3741C22.4338 9.64907 22.0398 9.01607 21.4568 8.67807C21.7218 8.34407 21.8808 7.92007 21.8808 7.46007C21.8808 6.63607 21.3708 5.92807 20.6518 5.63907C20.8628 5.32707 20.9868 4.95007 20.9868 4.54507C20.9868 3.46507 20.1128 2.58707 19.0378 2.58707C18.9832 2.58707 18.9232 2.58691 18.8584 2.58673C17.3039 2.58257 12.9068 2.57079 10.1758 4.57707C9.5677 5.02355 8.88343 5.31031 8.33011 5.48813Z"
        />
      <path d="M6.33011 15.5604V4.58237H1.56641V15.5604H6.33011Z" />
    </svg>
  </i>
  <kmd-tooltip-content #notusefulContent>
    <span class="tooltip-txt">Not useful</span> 
 </kmd-tooltip-content>
</div>

<!-- Feedback form -->
<div *ngIf="showFeedbackForm" class="feedback-container">
  <div class="feedback-form-header">
    <h6>Provide feedback on this response</h6>
    <svg class="float-end close-icon" (click)="closeFeedbackForm()" id="close-mono.svg" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M22 3.42L20.59 2L12 10.59L3.41003 2L2 3.42L10.59 12L2 20.59L3.41003 22L12 13.42L20.59 22L22 20.59L13.41 12L22 3.42Z" fill="#1B1B1D"/>
    </svg>
  </div>
  <div class="rating-container">
    <p>How would you rate the quality of the response received?</p>
    <div class="rating-options">
      <button kmdInfoButton size="lg" *ngFor="let rating of [1, 2, 3, 4, 5]"
              [ngClass]="{'selected': selectedRating === rating}"
              (click)="selectRating(rating)">
        {{ rating }}
      </button>
    </div>
    <div class="rating-labels">
      <span>Very poor</span>
      <span class="excellent">Excellent</span>
    </div>
  </div>
  
  <!-- Feedback subjects for thumbs down feedback -->
  <div *ngIf="feedbackType === 'thumbsDown'" class="feedback-subjects-container">
    <p class="feedback-subject-title">Feedback subject: (select all that apply)</p>
    
    <!-- Other feedback subject options -->
    <div *ngFor="let option of feedbackSubjectOptionsNew" class="feedback-subject-item">
      <kmd-checkbox 
        [name]="option.value" 
        [value]="option.value" 
        [label]="option.label" 
        [(ngModel)]="selectedFeedbackSubjects"
        [checked]="isSubjectSelected(option.value)"
        (onClick)="onFeedbackSubjectChange($event, option.value)">
      </kmd-checkbox>
      
      <!-- Show text input for "Other" option when selected -->
      <div *ngIf="option.value === 'other' && showOtherTextInput" class="other-text-container">
        <textarea 
          class="form-control other-text-input" 
          [(ngModel)]="otherFeedbackText" 
          placeholder="Please explain the issue"
          rows="3"></textarea>
      </div>
    </div>
  </div>
  
  <!-- Suggestions field for both thumbsUp and thumbsDown feedback -->
  <div class="feedback-suggestions-container">
    <p style="size: 14px; font-weight: 500;">Do you have any suggestions to improve our responses?<span style="color: #54545C; size: 12px; font-weight: 400;"> (Optional)</span></p>
    <textarea 
      class="form-control suggestions-textarea" 
      [(ngModel)]="feedbackSuggestions" 
      placeholder="Did the response align with your expectations? Let us know what we can do better"
      rows="3"></textarea>
  </div>
  <div class="feedback-info-container">
    <svg id="info-bold.svg" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.48 2 2 6.47998 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.47998 17.52 2 12 2ZM13.5 19H10.5V10H13.5V19ZM13.5 8H10.5V5H13.5V8Z" fill="#1B1B1D"/>
    </svg>
    <div class="feedback-info-message">By submitting your response, you consent to the collection of your prompt and email address for routing to the appropriate team.</div>
  </div>
  <div class="feedback-submit-container">
    <button kmdInfoButton class="cancel-feedback-button me-3" (click)="closeFeedbackForm()">Cancel</button>
    <button kmdFeaturedButton class="submit-feedback-button" [disabled]="!isFormValid()" (click)="submitFeedback()">Submit</button>
  </div>
</div>

<div *ngIf="showSuccessMessage && !showFeedbackForm" class="feedback-success-card">
  <kmd-alerts kmd-success alertTitle="Thanks for sharing your feedback!"  [floating]="true"  [show]="showSuccessMessage && !showFeedbackForm" [icon]="true">Your suggestion helps us improve and enhance your experience.</kmd-alerts>
</div>